import { render, staticRenderFns } from "./BaseNotAvaliable.vue?vue&type=template&id=68555a44&scoped=true&"
import script from "./BaseNotAvaliable.vue?vue&type=script&lang=js&"
export * from "./BaseNotAvaliable.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotAvaliable.vue?vue&type=style&index=0&id=68555a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68555a44",
  null
  
)

export default component.exports